import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { colors, actionButtonStyle } from '../../styles/designTokens';

// ── Styles ──────────────────────────────────────────────────

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'wrap',
};

const addEventsStyle = {
  ...actionButtonStyle,
  minWidth: '44px',
  minHeight: '44px',
  backgroundColor: 'transparent',
  color: colors.success,
  borderColor: colors.success,
};

const deleteStyle = {
  ...actionButtonStyle,
  minWidth: '44px',
  minHeight: '44px',
  backgroundColor: 'transparent',
  color: colors.urgent,
  borderColor: colors.urgent,
};

const mobileDeleteStyle = {
  ...actionButtonStyle,
  minWidth: '44px',
  minHeight: '44px',
  backgroundColor: 'transparent',
  color: colors.urgent,
  borderColor: colors.urgent,
  marginTop: '8px',
};

/**
 * TripActions — Desktop action control group and mobile delete affordance.
 *
 * Renders two desktop controls (Add Events, Delete Trip) and a
 * mobile-reachable delete control positioned near the top of the card body
 * so it's accessible without scrolling (Req 4.2).
 *
 * Props:
 * @param {() => void} onAddEvents — Opens the Edit Trip Modal
 * @param {() => void} onDeleteTrip — Initiates the delete confirmation flow
 */
function TripActions({ onAddEvents, onDeleteTrip }) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  return (
    <>
      {/* Desktop action controls */}
      {!isMobile && (
        <div style={containerStyle} data-testid="trip-actions-desktop">
          <button
            style={addEventsStyle}
            onClick={onAddEvents}
            data-testid="action-add-events"
            title="Add events to this trip"
            aria-label="Add events"
          >
            <Plus size={14} aria-hidden="true" />
            Add Events
          </button>

          <button
            style={deleteStyle}
            onClick={onDeleteTrip}
            data-testid="action-delete-trip"
            title="Delete this trip"
            aria-label="Delete trip"
          >
            <Trash2 size={14} aria-hidden="true" />
            Delete Trip
          </button>
        </div>
      )}

      {/* Mobile delete affordance — reachable without scrolling (Req 4.2) */}
      {isMobile && (
        <button
          style={mobileDeleteStyle}
          onClick={onDeleteTrip}
          data-testid="mobile-action-delete-trip"
          title="Delete this trip"
          aria-label="Delete trip"
        >
          <Trash2 size={14} aria-hidden="true" />
          Delete Trip
        </button>
      )}
    </>
  );
}

export default TripActions;
